import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { CmsContentComponent } from './shared/components/cms-content/cms-content.component';


import { AuthenticationService } from './core/services/authentication/authentication.service';
import { AuthGuard } from './core/guards/auth.guard';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { SignoutCallbackComponent } from './signout-callback/signout-callback.component';
import { ModuleAccessGuard } from './core/guards/module-access-guard.guard';
import { Constants } from './shared/constants';
import { ErrorPageComponent } from './shared/components/error-page/error-page.component';
import { UnauthorizePageComponent } from './shared/components/unauthorize-page/unauthorize-page.component';
import { LogoutComponent } from './logout/logout.component';

const routes: Routes = [
  // { path: '', redirectTo: '/login', pathMatch: 'full', canActivate: [AuthGuard] },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'assets/app.config.json?rel=v_', redirectTo: '/dashboard', pathMatch: 'prefix' },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard], data: { pageTitle: 'Welcome to Partner Center' } },
  { path: 'logout', component: LogoutComponent },
  { path: 'error', component: ErrorPageComponent },
  { path: 'unauthorized', component: UnauthorizePageComponent },

  {
    path: 'about-us', component: CmsContentComponent,
    data: {
      title: 'About Us | Partner Center'
    }
  },
  { path: 'terms-of-use', component: CmsContentComponent },
  {
    path: 'privacy-policies', component: CmsContentComponent,
    data: {
      title: 'Privacy Policies | Partner Center'
    }
  },
  {
    path: 'contact-us', component: CmsContentComponent,
    data: {
      title: 'Contact Us | Partner Center'
    }
  },//Contact-us new 
  {
    path: Constants.WaiverManagementPath,
    canActivate: [AuthGuard, ModuleAccessGuard],
    loadChildren: () => import('./waiver-management/waiver-management.module').then(m => m.WaiverManagementModule),
  },
  {
    path: Constants.ClaimsPath,
    canActivate: [AuthGuard, ModuleAccessGuard],
    loadChildren: () => import('./claims-management/claims-management.module').then(m => m.ClaimsManagementModule),
  },
  {
    path: Constants.PaymentPath,
    canActivate: [AuthGuard, ModuleAccessGuard],
    loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule)
  },
  {
    path: Constants.InsuranceManagementPath,
    canActivate: [AuthGuard, ModuleAccessGuard],
    loadChildren: () => import('./insurance-management/insurance-management.module').then(m => m.InsuranceManagementModule)
  },
  {
    path: Constants.SchoolSetupPath,
    canActivate: [AuthGuard, ModuleAccessGuard],
    loadChildren: () => import('./school-setup/school-setup.module').then(m => m.SchoolSetupModule)
  },
  {
    path: 'auth-callback',
    component: AuthCallbackComponent
  },
  {
    path: 'signout-callback',
    component: SignoutCallbackComponent
  },
  {
    path: 'silent-refresh',
    component: AuthCallbackComponent
  },
  { path: '**', redirectTo: '/dashboard' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard, AuthenticationService, ModuleAccessGuard]
})
export class AppRoutingModule { }
